<div class="paginator-container">
  <button
    (click)="content.current !== 1 ? move('-') : null"
    [ngClass]="[content.current !== 1 ? 'previous' : 'previous--hide']"
    [class.previous]="content.current !== 1"
    [class.previous--hide]="content.current === 1"
    class="previous"
    href="javascript:void(0)"
    role="button"
    [attr.aria-disabled]="content.current === 1 ? 'true' : 'false'"
  >
    <span class="sr-only">{{ content.ariaLabels.previous }}</span>
  </button>

  <label class="paginator-container__indicator" href="javascript:void(0)">
    <span class="sr-only">{{ content.ariaLabels.indicator }}</span>
    {{ content.label }}
  </label>

  <button
    (click)="content.current !== content.total ? move('+') : null"
    [class.next]="content.current !== content.total"
    [class.next--hide]="content.current === content.total"
    href="javascript:void(0)"
    role="button"
    [attr.aria-disabled]="content.current === content.total ? 'true' : 'false'"
  >
    <span class="sr-only">{{ content.ariaLabels.next }}</span>
  </button>
</div>
